import CreateProjectPage from "./create-project";

export default CreateProjectPage;
